import {Alert, Button, Col, message, Modal, Row, Spin, Typography} from 'antd'
import React, {Component} from 'react'

import cookie from 'react-cookies'
import 'asset/style/dashboard.css'
import 'asset/style/add_case.css'
import 'asset/style/utils/confirm.userpermissions.css'
import 'asset/style/theme/theme.scoped.scss';
import {isArrayEqual} from 'utils/utils'
import {aclPermissions, hasPermissions} from 'const/ACLPermissions'
import {
    getUserAccessPermissionsAndPolicy,
    updateAccessPermissionsForUser,
    updateMembersInAccessPolicy
} from "../../../utils/api";
import {antdSpinLoaderIcon} from "../../../utils/const";

const { Text } = Typography;

class ConfirmUserPermissions extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currPolicy: '',
            currPolicyPermissions: [],
            currUserPermissions: [],
            isFetching: false,
        }
    }

    componentDidMount() {
        if (!hasPermissions([aclPermissions.view_other_user_permissions]) &&
            this.props.username !== cookie.load("username")) {
            this.props.closeModal("NO_CHANGE")
        }
        this.setState({isFetching: true})
        getUserAccessPermissionsAndPolicy(this.props.username)
            .then(data => {
                const currPolicy = data.policy || ''

                const currPolicyPermissions =
                    currPolicy ?
                        this.props.allPolicies
                            ?.find(p => p.name === data.policy)
                            ?.access_permissions
                        : []

                const currUserPermissions =
                    data.permissions
                        ?.filter(p => !currPolicyPermissions?.includes(p))
                    || []


                if (this.noChanges({currPolicy, currPolicyPermissions, currUserPermissions})) {
                    this.props.closeModal("NO_CHANGE")
                }

            this.setState({
                currPolicy,
                currPolicyPermissions,
                currUserPermissions,
                isFetching: false,
            })
        })
            .catch((err) => {
                if (err?.response?.status !== 403) {
                    message.error("Failed to fetch User Policy and Permissions. Contact Admin")
                }
            })
    }

    noChanges = ({currPolicy, currPolicyPermissions, currUserPermissions}) => {
        const policyPermsEqual = isArrayEqual(currPolicyPermissions, this.props.updatedPolicyPermissions)
        const userPermsEqual = isArrayEqual(currUserPermissions, this.props.updatedUserPermissions)
        const policyEqual = currPolicy === this.props.updatedPolicy || (!currPolicy && !this.props.updatedPolicy)

        return policyEqual && policyPermsEqual && userPermsEqual            
    }

    renderPermissionAudit({ currPolicyPerms, updatedPolicyPerms, currUserPerms, updatedUserPerms }) {
        const allPerms = this.props.allPermissions
        const allCategories = this.props.allCategories || []

        const elems = []
        const addedPerms = []
        const removedPerms = []
        const unchangedPerms = []
        const absentPerms = []

        for (const {name, label, category} of allPerms) {
            const isInCurrUser = currUserPerms.includes(name)
            const isInCurrPolicy = currPolicyPerms.includes(name)

            const isInUpdatedUser = updatedUserPerms.includes(name)
            const isInUpdatedPolicy = updatedPolicyPerms.includes(name)

            const isPolicyPerm = isInCurrPolicy || isInUpdatedPolicy

            const isCurrPerm = (isInCurrUser || isInCurrPolicy) - 0 + ''
            const isUpdatePerm = (isInUpdatedUser || isInUpdatedPolicy) - 0 + ''

            const status = isUpdatePerm + isCurrPerm
            let classes = ['perm'];

            switch (status) {
                case '10':
                    addedPerms.push({name, label, category, isCurrPerm, isPolicyPerm, className: 'perm-added'})
                    classes.push('perm-added')
                    break
                case '01':
                    removedPerms.push({name, label, category, isCurrPerm, isPolicyPerm, className: 'perm-deleted'})
                    classes.push('perm-deleted')
                    break
                case '11':
                    unchangedPerms.push({name, label, category, isCurrPerm, isPolicyPerm, className: 'perm-selected'})
                    classes.push('perm-selected')
                    break
                default:
                    absentPerms.push({name, label, category, isCurrPerm, isPolicyPerm, className: 'perm-absent'})

            }
        }

        for (const {
            name,
            label,
            category,
            isCurrPerm,
            isPolicyPerm,
            className
        } of [...addedPerms, ...removedPerms, ...unchangedPerms, ...absentPerms]) {
            const policy = (isCurrPerm - 0) ? this.state.currPolicy : this.props.updatedPolicy;

            const elem = (
                <div key={`perm_${name}`} className={`perm ${className}`}>
                    <div>
                        {this.props.retainPermissions ? `${label}` : `${label} ${isPolicyPerm ? `(inherited from ${policy})` : ''}`}
                    </div>
                    <div style={{fontSize: 11}}>
                        <span style={{fontStyle: "italic"}}>{allCategories.find(c => c.name === category)?.label}</span>
                    </div>
                </div>
            )
            elems.push(elem)
        }

        return elems.map(elem => elem)
    }

    save() {
        try {
            if (this.state.currPolicy !== this.props.updatedPolicy) {
                const data = {
                    update_member_usernames: [this.props.username],
                    organisation: this.props.organisation
                }

                if (this.state.currPolicy) {
                    data.name = this.state.currPolicy
                    data.action = 'remove'

                    updateMembersInAccessPolicy(data)
                        .catch(() => message.error("Failed to Update Policy details. Contact Admin"))
                }

                if (this.props.updatedPolicy) {
                    data.name = this.props.updatedPolicy
                    data.action = 'add'

                    updateMembersInAccessPolicy(data)
                        .catch(() => message.error("Failed to Update Policy details. Contact Admin"))
                }
            }

            const data = {username: this.props.username}

            data['update_permissions'] = this.props.updatedUserPermissions
            updateAccessPermissionsForUser(data)
                .catch((error) => {
                    if(error.response.data.includes("ACL")){
                        message.error(error.response.data)
                    }else{
                        message.error("Failed to Update Policy details. Contact Admin")
                    }
                })
            this.props.closeModal("SAVED")

        } catch (err) {
            message.error("Failed to Update Policy details. Contact Admin");
            this.props.closeModal("ERROR")
        }
    }

    close() {
        this.props.closeModal("CANCEL")
    }

    render() {
        return (
            <Modal
                title={<Typography>
                    <div style={{fontSize: 20, fontWeight: 400}}>Confirm Permissions</div>
                </Typography>}
                onOk={() => this.save()}
                onCancel={() => this.close()}
                visible={this.props.visible}
                footer={<div>
                    <Button onClick={() => this.close()} type={"danger"} ghost>
                        Cancel
                    </Button>
                    <Button
                        onClick={() => this.save()}
                        type="primary" ghost
                    >
                        OK
                    </Button>
                </div>}
            >
                <Spin spinning={this.state.isFetching} indicator={antdSpinLoaderIcon}>
                    <Row className="audit-info">
                        <Row>
                            <Col span={5} className="add-case-row-header">
                                <b style={{fontSize: 14, fontWeight: 800}}>Username</b>
                            </Col>
                            <Col span={8} className="add-case-row-header">
                                <b style={{fontSize: 14, fontWeight: 400}}>{this.props.username}</b>
                            </Col>
                        </Row>
                        {(this.state.currPolicy !== this.props.updatedPolicy) ?
                            (
                                <Row>
                                    <Row>
                                        <Col span={5} className="add-case-row-header">
                                            <b style={{fontSize: 14, fontWeight: 800}}>Old Policy</b>
                                        </Col>
                                        <Col className="add-case-row-header">
                                            <b style={{
                                                fontSize: 14,
                                                fontWeight: 400
                                            }}>{this.state.currPolicy || '-'}</b>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={5} className="add-case-row-header">
                                            <b style={{fontSize: 14, fontWeight: 800}}>New Policy</b>
                                        </Col>
                                        <Col className="add-case-row-header">
                                            <b style={{fontSize: 14, fontWeight: 400}}>{this.props.updatedPolicy}</b>
                                        </Col>
                                    </Row>
                                </Row>
                            ) : (
                                <Row>
                                    <Col span={5} className="add-case-row-header">
                                        <b style={{fontSize: 14, fontWeight: 800}}>Policy</b>
                                    </Col>
                                    <Col span={8} className="add-case-row-header">
                                        <b style={{fontSize: 14, fontWeight: 400}}>{this.state.currPolicy || '-'}</b>
                                    </Col>
                                </Row>
                            )
                        }
                    </Row>
                    <Row>
                        <Col>
                            <Text style={{
                                fontStyle: "italic",
                                color: "green",
                                display: "flex",
                                justifyContent: "center"
                            }}>
                                <Alert message="Changes will be reflected on subsequent login" type="success"/>
                            </Text>
                        </Col>
                    </Row>
                    <Row>
                        <Row className="add-case-row-header" style={{marginTop: "10px"}}>
                            <div style={{fontSize: 16, fontWeight: 400}}>Permissions Preview</div>
                        </Row>
                        <div className="audit-window scrollbar" style={{border: "none"}}>
                            {this.renderPermissionAudit({
                                currUserPerms: this.state.currUserPermissions || [],
                                currPolicyPerms: this.state.currPolicyPermissions || [],
                                updatedUserPerms: this.props.updatedUserPermissions || [],
                                updatedPolicyPerms: this.props.updatedPolicyPermissions || [],
                            })}
                        </div>
                    </Row>
                    <Row className="legend">
                        <Row className="add-case-row-header legend-header">
                            <b>Legends</b>
                        </Row>
                        <Row span={24}>
                            <Col span={6}>
                                        <div className="legend-box perm-added">Added</div>
                            </Col>
                            <Col span={6}>
                                        <div className="legend-box perm-deleted">Removed</div>
                            </Col>
                            <Col span={6}>
                                        <div className="legend-box perm-selected">Unchanged</div>
                            </Col>
                            <Col span={6}>
                                        <div className="legend-box perm">Absent</div
                                        >
                            </Col>
                        </Row>
                    </Row>
                </Spin>
            </Modal>
        )
    }
}

export default ConfirmUserPermissions